import { Icon } from '@elotech/components';
import classnames from 'classnames';
import * as authActions from 'common/auth/Actions.js';
import AuthService from 'common/auth/AuthService.js';
import {
  offsidebarUsuarioAndEntidadeInativa,
  offsidebarUsuarioAndEntidadeToggle,
  offsidebarUsuarioSobreVersao,
  offsidebarUsuarioToggle
} from 'common/ui/Actions.js';
import keycloakService from 'keycloak/KeycloakService.js';
import { useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ShepherdTourContext } from 'react-shepherd';

import EntidadeForm from '../entidades/Form.react.js';
import OffSidebarVersionInfo from './OffSidebarVersionInfo.jsx';

const OffSidebarUsuario = ({
  ui,
  hideTrocarEntidade,
  auth,
  offsidebarUsuarioAndEntidadeToggle,
  offsidebarUsuarioAndEntidadeInativa,
  offsidebarUsuarioSobreVersao,
  logout,
  config,
  info
}) => {
  const tour = useContext(ShepherdTourContext);

  const onLogout = event => {
    event.preventDefault();

    AuthService.clearAuthentication();
    AuthService.clearUserInfo();

    if (config.isCloud) {
      return keycloakService.logout();
    } else {
      logout();
      window.location.reload();
    }
  };

  const onProfile = () => {
    if (config.isCloud) {
      return keycloakService.redirectToUserProfile();
    }
  };

  const getUsuarioName = () => {
    return auth.getIn(['userInfo', 'nome']);
  };

  const isUserLogged = () => {
    return auth.get('logged');
  };

  const className = classnames('features-user auto-height overflow-visible', {
    active: ui.offsidebarUsuarioToggled
  });

  const onClickNovidadesVersao = () => {
    window.open(
      'https://atendimento.elotech.com.br/hc/pt-br/sections/4410778272019-Oxy-Protocolo'
    );
  };

  const renderChildren = () => {
    if (ui.offsidebarUsuarioEntidadeAtiva) {
      return <EntidadeForm onVoltar={offsidebarUsuarioAndEntidadeInativa} />;
    } else if (ui.offsidebarUsuarioVersaoToggled) {
      return (
        <OffSidebarVersionInfo
          info={info}
          offsidebarUsuarioSobreVersao={offsidebarUsuarioSobreVersao}
          onClickNovidadesVersao={onClickNovidadesVersao}
        />
      );
    } else {
      return (
        <>
          <h2 className="title">Ajustes</h2>
          <ul className="user-actions">
            <li className="features-section">Minha conta</li>

            <li onClick={onProfile}>
              <Icon icon="user" className="icon" />
              <article>
                <label>Usuário</label>
                {getUsuarioName() || auth.getIn(['userInfo', 'usuario'])}
              </article>
            </li>

            {tour ? (
              <li className="no-link" onClick={tour.start}>
                <Icon icon="plane-departure" className="icon" />
                Fazer o tour novamente.
              </li>
            ) : null}

            {hideTrocarEntidade && (
              <>
                <li className="features-section">Parâmetros</li>
                <li onClick={offsidebarUsuarioAndEntidadeToggle}>
                  <Icon icon="building" className="icon" />
                  <article>
                    <label>Entidade</label>
                    {auth.getIn(['userInfo', 'entidade', 'nome'])}
                  </article>
                </li>
              </>
            )}

            <li onClick={offsidebarUsuarioSobreVersao}>
              <Icon icon="info-circle" className="icon" />
              Sobre o sistema
            </li>

            <li className="logout" onClick={onLogout}>
              <Icon icon="sign-out-alt" className="icon" /> Sair
            </li>
          </ul>
        </>
      );
    }
  };

  if (isUserLogged() && ui.offsidebarUsuarioToggled) {
    return <div className={className}>{renderChildren()}</div>;
  }

  return null;
};

const allActions = {
  ...authActions,
  offsidebarUsuarioToggle,
  offsidebarUsuarioAndEntidadeToggle,
  offsidebarUsuarioAndEntidadeInativa,
  offsidebarUsuarioSobreVersao
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    ui: state.ui,
    config: state.config,
    info: state.info
  };
}

const connectedComponent = connect(
  mapStateToProps,
  allActions
)(withRouter(OffSidebarUsuario));

export default connectedComponent;
